import { render } from "./Margin.vue?vue&type=template&id=ee43fd56&scoped=true"
import script from "./Margin.vue?vue&type=script&lang=js"
export * from "./Margin.vue?vue&type=script&lang=js"

import "./Margin.vue?vue&type=style&index=0&id=ee43fd56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee43fd56"]])

export default __exports__